/** Purchase-order quantity badge. Not the dock-container filter. */
export function isInboundRowFullyReceived(row: {
  expected_quantity: string;
  system_received_quantity: string;
}): boolean {
  const expectedQuantity = Number(row.expected_quantity) || 0;
  const receivedQuantity = Number(row.system_received_quantity) || 0;
  return expectedQuantity > 0 && receivedQuantity >= expectedQuantity;
}

/**
 * Every dock unit on the order has a submitted receipt.
 * Orders with no dock tags are not finished.
 */
export function isInboundRowAllContainersFinished(row: {
  arrival_containers?: ReadonlyArray<{ received_at: string | null }> | null;
}): boolean {
  const containers = row.arrival_containers ?? [];
  if (containers.length === 0) return false;
  return containers.every((container) => container.received_at != null);
}
